if (!customElements.get('product-card')) {
  customElements.define('product-card', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-image]').forEach(function (s) {
        new Image().src = s.dataset.image;
      });

      this._handleClick = this._handleClick.bind(this);
      this._handleKeydown = this._handleKeydown.bind(this);
      this.addEventListener('click', this._handleClick);

      this._modal = null;
      this._triggerBtn = null;
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._handleClick);
      document.removeEventListener('keydown', this._handleKeydown);
    }

    _handleClick(e) {
      /* Quick view open */
      if (e.target.closest('[data-quick-view-open]')) {
        e.preventDefault();
        this._triggerBtn = e.target.closest('[data-quick-view-open]');
        this._openModal();
        return;
      }

      /* Quick view close */
      if (e.target.closest('[data-quick-view-close]') || e.target.closest('[data-quick-view-backdrop]')) {
        this._closeModal();
        return;
      }

      /* Color swatch on card */
      var swatch = e.target.closest('[data-product-id]');
      if (!swatch) return;

      var productId = swatch.dataset.productId;
      var img = this.querySelector('[data-product-image="' + productId + '"]');
      if (img) img.src = swatch.dataset.image;

      var variantUrl = swatch.dataset.variantUrl;
      if (variantUrl) {
        this.querySelectorAll('[data-product-link]').forEach(function(link) {
          link.href = variantUrl;
        });
      }

      var siblings = swatch.parentElement.querySelectorAll('[data-product-id]');
      siblings.forEach(function (s) {
        s.classList.remove('border-current', 'ring-1', 'ring-inset', 'ring-white');
        s.classList.add('border-gray-200');
        s.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.remove('border-gray-200');
      swatch.classList.add('border-current', 'ring-1', 'ring-inset', 'ring-white');
      swatch.setAttribute('aria-pressed', 'true');
    }

    _openModal() {
      if (!this._modal) {
        var template = this.querySelector('template[data-quick-view-template]');
        if (!template) return;
        this.appendChild(template.content.cloneNode(true));
        this._modal = this.querySelector('[data-quick-view-modal]');
        if (!this._modal) return;
      }
      this._modal.classList.remove('opacity-0', 'pointer-events-none');
      this._modal.style.pointerEvents = 'auto';
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._handleKeydown);
    }

    _closeModal() {
      if (!this._modal) return;
      this._modal.classList.add('opacity-0', 'pointer-events-none');
      this._modal.style.pointerEvents = '';
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._handleKeydown);
      if (this._triggerBtn) {
        this._triggerBtn.focus();
        this._triggerBtn = null;
      }
    }

    _handleKeydown(e) {
      if (e.key === 'Escape') this._closeModal();
    }
  });
}
